import { FiltersType } from "src/components/shared-components/enum/enumFilters";

export class Filter {
  Kind: FiltersType = FiltersType.text;
  Name: string = "";
  Title: string = "";
  PlaceHolder: string = "";
  Values: FilterValues[] = [];
  InputValue: string = "";
}

export class FilterValues {
  Id: any = null;
  Value: string = "";
}
